module.exports = __webpack_public_path__ + "static/media/login-clinic.65703f43.jpg";